module.exports = __webpack_public_path__ + "static/media/feedback.b16620a8.png";